const validateForm = (formValues) => {
  const errors = {};

  /* This validator is descomment when the exist API whit email  */

  // Email validation
  if (!formValues.userName.trim()) {
    errors.userName = "El usuario es necesario.";
  } else if (formValues.userName.length < 2) {
    errors.userName = "Ingrese un usuario valido.";
  }

  // Password validation
  if (!formValues.password) {
    errors.password = "La contraseña es necesaria.";
  }

  return errors;
};
export default validateForm;
